var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import "antd/dist/antd.css";
import "./App.css";
import { TABLET_WIDTH } from "@codex/utils/constants";
import { Provider } from "react-redux";
import { store } from "./store";
import { IntlProvider } from "react-intl";
import messages from "@codex/utils/language/hebrew";
import Modal from "@codex/components/Modal";
import Routes from "./routes";
import BlockUi from "./containers/BlockUi";
import ConfigProvider from "antd/lib/config-provider";
import he from "antd/es/locale/he_IL";
export var AppContext = React.createContext({
    isMobileScreen: false
});
var App = /** @class */ (function (_super) {
    __extends(App, _super);
    function App() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isMobileScreen: false
        };
        _this.onResizeWindow = function (evt) {
            _this.setState({
                isMobileScreen: evt.currentTarget.outerWidth <= TABLET_WIDTH
            });
        };
        return _this;
    }
    App.prototype.componentDidMount = function () {
        this.setState({ isMobileScreen: window.outerWidth <= TABLET_WIDTH });
        window.addEventListener("resize", this.onResizeWindow);
    };
    App.prototype.render = function () {
        return (React.createElement(ConfigProvider, { locale: he },
            React.createElement(IntlProvider, { locale: "he", messages: messages },
                React.createElement(Provider, { store: store },
                    React.createElement(AppContext.Provider, { value: this.state },
                        React.createElement(BlockUi, null,
                            React.createElement(Routes, null))),
                    React.createElement(Modal, null)))));
    };
    return App;
}(Component));
export default App;



//////////////////
// WEBPACK FOOTER
// ./src/App.tsx
// module id = 129
// module chunks = 0